import React, { useState, useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex min-h-screen">
        {/* Sidebar */}
        <Sidebar 
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarVisible={sidebarVisible}
          setSidebarVisible={setSidebarVisible}
          activeDropdown={activeDropdown}
          setActiveDropdown={setActiveDropdown}
        />

        {/* Main Content */}
        <div className={`flex-1 flex flex-col min-h-screen ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'} transition-all duration-300 ${sidebarVisible ? 'lg:ml-64' : 'lg:ml-16'}`}>
          {/* Navbar */}
          <Navbar 
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarVisible={sidebarVisible}
            setSidebarVisible={setSidebarVisible}
            activeDropdown={activeDropdown}
          />

          {/* Main Content Area */}
          <main className={`flex-1 p-6 overflow-y-auto ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'} mt-16 lg:mt-0`}>
            <div className="max-w-7xl mx-auto space-y-8">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
